import Link from 'next/link';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  height: 1.75rem;
  padding: 4px 5px;
  border-radius: 1rem;
  background: ${({ theme }) => theme.tokens.colors.neutral[300]};
`;

export const Tab = styled(Link)<{ $active?: boolean }>`
  border-radius: 1rem;
  padding: 0 1rem;
  border: none;
  background: transparent;
  font-weight: 500;
  color: ${({ theme }) => theme.tokens.colors.text[200]};
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.tokens.colors.text.base};
    background: ${({ theme }) => theme.tokens.colors.neutral[100]};
    box-shadow: 0 5px 10px -7px rgba(0, 0, 0, 0.2);
  }

  ${({ $active, theme }) =>
    $active &&
    `
      color: ${theme.tokens.colors.text.base};
      background: ${theme.tokens.colors.neutral[100]};
      box-shadow: 0 5px 10px -7px rgba(0, 0, 0, 0.2);
    `}
`;
